import { Suspense, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router';

import { useQueryReadSearchParams } from '@src/api/queries/global.queries';
import { Loader } from '@src/components/ui/Loader';
import {
  getCurrentPathnames,
  getLocaleCodeBySubdomain,
} from '@src/helpers/host.helpers';
import {
  dayjsUpdateLocale,
  onChangeLanguage,
} from '@src/helpers/locales.helpers';
import { useScrollPageToTop } from '@src/hooks/useScrollPageToTop';

export const RootRouter = () => {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();

  useScrollPageToTop();

  const { IS_NEW_PASSWORD_PAGE, IS_CREATE_PASSWORD_PAGE } =
    getCurrentPathnames(pathname);

  useQueryReadSearchParams({
    enabled: !IS_NEW_PASSWORD_PAGE && !IS_CREATE_PASSWORD_PAGE,
  });

  useLayoutEffect(() => {
    const region = getLocaleCodeBySubdomain();
    onChangeLanguage(region);
  }, []);

  useLayoutEffect(() => {
    dayjsUpdateLocale(i18n);
  }, [i18n]);

  return (
    <Suspense fallback={<Loader show />}>
      <Outlet />
    </Suspense>
  );
};
